"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.clientShow = clientShow;
Object.defineProperty(exports, "MobileSiteNavigation", {
  enumerable: true,
  get: function get() {
    return _$previous.MobileSiteNavigation;
  }
});
Object.defineProperty(exports, "AnimatedContainer", {
  enumerable: true,
  get: function get() {
    return _$previous.AnimatedContainer;
  }
});
Object.defineProperty(exports, "showMobile", {
  enumerable: true,
  get: function get() {
    return _$previous.showMobile;
  }
});
exports.ClientSelect = exports.default = void 0;

var _$previous = babelHelpers.interopRequireWildcard(require("$previous"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _facilitiesModal = babelHelpers.interopRequireDefault(require("modals/facilities-modal"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _temp, _class3, _descriptor2, _temp2;

var PrositeSiteNavigation =
/*#__PURE__*/
function (_DefaultSiteNavigatio) {
  babelHelpers.inherits(PrositeSiteNavigation, _DefaultSiteNavigatio);

  function PrositeSiteNavigation() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PrositeSiteNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PrositeSiteNavigation)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = Object.assign(_this.state, {
      client: null
    });
    return _this;
  }

  babelHelpers.createClass(PrositeSiteNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _babelHelpers$get;

      PrositeSiteNavigation.currentNav = this;
      (0, _fetch.default)('data/cart/client').then(function (d) {
        return d.json();
      }).then(function (client) {
        return _this2.setState({
          client: client
        });
      });

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidMount", this)) (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidMount", this)).call.apply(_babelHelpers$get, [this].concat(args));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.userProfile.id != this.props.userProfile.id) PrositeSiteNavigation.clientUpdated();
      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidUpdate", this)) babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _babelHelpers$get2;

      if (PrositeSiteNavigation.currentNav == this) PrositeSiteNavigation.currentNav = null;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentWillUnmount", this)) (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentWillUnmount", this)).call.apply(_babelHelpers$get2, [this].concat(args));
    }
  }, {
    key: "renderExtraElements",
    value: function renderExtraElements() {
      if (this.state.profile && !this.state.profile.guest) {
        return _react.default.createElement(_react.Fragment, null, _react.default.createElement(ClientSelect, {
          client: this.state.client
        }));
      }

      return null;
    }
  }], [{
    key: "clientUpdated",
    value: function clientUpdated() {
      var _this3 = this;

      if (this.currentNav) (0, _fetch.default)('data/cart/client').then(function (d) {
        return d.json();
      }).then(function (client) {
        return _this3.currentNav.setState({
          client: client
        });
      });
    }
  }]);
  return PrositeSiteNavigation;
}(_$previous.default);

exports.default = PrositeSiteNavigation;
var MaybeLinked = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MaybeLinked, _Component);

  function MaybeLinked() {
    var _babelHelpers$getProt2;

    var _this4;

    babelHelpers.classCallCheck(this, MaybeLinked);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(MaybeLinked)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "linked", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(MaybeLinked, [{
    key: "render",
    value: function render() {
      var x = Object.assign({}, this.props);
      delete x.linked;
      var Type;

      if (this.linked) {
        Type = 'a';
      } else {
        Type = 'div';
        delete x.href;
      }

      return _react.default.createElement(Type, x);
    }
  }]);
  return MaybeLinked;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linked", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ClientSelect = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ClientSelect, _Component2);

  function ClientSelect() {
    var _babelHelpers$getProt3;

    var _this5;

    babelHelpers.classCallCheck(this, ClientSelect);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(ClientSelect)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "client", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      cart: null,
      logoErr: false
    };
    return _this5;
  }

  babelHelpers.createClass(ClientSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ClientSelect.current = this;
      this.fetchCart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (ClientSelect.current == this) ClientSelect.current = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((prevProps.client || {
        id: null
      }).id != (this.client || {
        id: null
      }).id) {
        this.fetchCart();
        this.setState({
          logoErr: false
        });
      }
    }
  }, {
    key: "setCart",
    value: function setCart(data) {
      this.setState({
        cart: data
      });
    }
  }, {
    key: "fetchCart",
    value: function fetchCart() {
      var _this6 = this;

      (0, _fetch.default)('data/cart').then(function (d) {
        return d.json();
      }).then(function (contents) {
        return _this6.setCart(contents);
      });
    }
  }, {
    key: "err",
    value: function err() {
      this.setState({
        logoErr: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.client) return null;
      var contents = this.state.cart || [];
      return _react.default.createElement("div", {
        className: "facility-btn"
      }, _react.default.createElement(MaybeLinked, {
        href: "orderreview",
        linked: contents.length
      }, !this.state.logoErr && this.client.logo ? _react.default.createElement("span", {
        className: "logo",
        "data-badge": contents.length > 9 ? '*' : contents.length || void 0
      }, _react.default.createElement("img", {
        src: this.client.logo,
        onError: this.err
      })) : _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "shopping_cart",
        "data-badge": contents.length > 9 ? '*' : contents.length || void 0
      }), _react.default.createElement("p", null, this.client.name)), this.client.hasMultiple && _react.default.createElement("a", {
        onClick: this.selectClient,
        href: "javascript:void(0)",
        className: "change-btn"
      }, _react.default.createElement("i", {
        className: "material-icons"
      }, "keyboard_arrow_down")));
    }
  }, {
    key: "selectClient",
    value: function selectClient() {
      _facilitiesModal.default.show();
    }
  }]);
  return ClientSelect;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "client", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "err", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "err"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectClient", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "selectClient"), _class3.prototype)), _class3);
exports.ClientSelect = ClientSelect;

function show(parent, props) {
  _reactDom.default.render(_react.default.createElement(PrositeSiteNavigation, props), parent);
}

function clientShow(props) {
  show(document.querySelector('#nav-container'), props);
}